// Κεντρικό αρχείο περιεχομένου — όλα τα κείμενα είναι επεξεργάσιμα από εδώ.

export const brand = {
  name: "Alumak Doors & Windows",
  short: "Alumak",
  logo: "https://customer-assets.emergentagent.com/job_aluminium-pro-gr/artifacts/8asmpoff_image.png",
  phones: [
    { label: "Σταθερό", number: "2532041242", display: "25320 41242", whatsapp: false },
    { label: "Κινητό", number: "6936351901", display: "6936 351 901", whatsapp: true },
    { label: "Κινητό", number: "6974824281", display: "6974 824 281", whatsapp: true },
  ],
  // Primary phone (for header & tel: links)
  phone: "2532041242",
  phoneDisplay: "25320 41242",
  // Primary WhatsApp number (first mobile)
  whatsapp: "306936351901",
  email: "info@alumak.gr",
  area: "Ροδόπη & ευρύτερη περιοχή Β. Ελλάδας",
  address: "Μύστακας, Ροδόπης",
  hours: "Δευ–Παρ 09:00–19:00 • Σάβ 10:00–14:00",
  mapsEmbed:
    "https://www.google.com/maps?q=Mystakas+Rodopis+Greece&output=embed",
  mapsLink: "https://www.google.com/maps/search/?api=1&query=Mystakas+Rodopis+Greece",
};

export const nav = [
  { id: "home", label: "Αρχική" },
  { id: "products", label: "Προϊόντα" },
  { id: "projects", label: "Έργα" },
  { id: "why", label: "Γιατί Alumak" },
  { id: "process", label: "Διαδικασία" },
  { id: "showroom", label: "Showroom" },
  { id: "contact", label: "Επικοινωνία" },
];

export const hero = {
  image:
    "https://images.unsplash.com/photo-1775116483656-dd06d21ef928?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBsdXh1cnklMjBob3VzZSUyMGV4dGVyaW9yJTIwbGFyZ2UlMjB3aW5kb3dzfGVufDB8fHx8MTc3Nzk3MjkyM3ww&ixlib=rb-4.1.0&q=85",
  eyebrow: "Alumak Doors & Windows",
  title: "Σύγχρονα Κουφώματα Αλουμινίου για Κάθε Χώρο",
  subtitle:
    "Η Alumak Doors & Windows σχεδιάζει και τοποθετεί ποιοτικές λύσεις αλουμινίου για κατοικίες, επαγγελματικούς χώρους και ξενοδοχειακές μονάδες.",
  primaryCta: "Ζητήστε Προσφορά",
  secondaryCta: "Κλείστε Ραντεβού στο Showroom",
  trust: [
    "Ενεργειακή Απόδοση",
    "Μοντέρνος Σχεδιασμός",
    "Άριστη Τοποθέτηση",
  ],
};

export const products = {
  eyebrow: "Προϊόντα",
  title: "Ολοκληρωμένες Λύσεις Αλουμινίου",
  subtitle:
    "Από κουφώματα υψηλής θερμομόνωσης έως πέργκολες και γυάλινα διαχωριστικά — ό,τι χρειάζεται ο χώρος σας.",
  items: [
    {
      id: "kofomata",
      title: "Κουφώματα Αλουμινίου",
      description:
        "Ανοιγόμενα και συρόμενα συστήματα υψηλής θερμομόνωσης και αντοχής.",
      image:
        "https://images.unsplash.com/photo-1698892472816-9c08eb4b13c1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBsYXJnZSUyMGFsdW1pbml1bSUyMHdpbmRvdyUyMG5hdHVyZXxlbnwwfHx8fDE3Nzc5NzI5Mjl8MA&ixlib=rb-4.1.0&q=85",
    },
    {
      id: "portes",
      title: "Πόρτες Εισόδου",
      description:
        "Ασφάλεια, αισθητική και κορυφαία ποιότητα κατασκευής για την είσοδο του χώρου σας.",
      image:
        "https://images.unsplash.com/photo-1722942625548-f11eed364eae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBibGFjayUyMGVudHJhbmNlJTIwZG9vciUyMGhvdXNlfGVufDB8fHx8MTc3Nzk3MjkyM3ww&ixlib=rb-4.1.0&q=85",
    },
    {
      id: "rola",
      title: "Ρολά & Παντζούρια",
      description:
        "Λύσεις σκίασης, προστασίας και ιδιωτικότητας με σύγχρονη αισθητική.",
      image:
        "https://images.unsplash.com/photo-1632904776796-22b5435c4bb5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBob3VzZSUyMGV4dGVyaW9yJTIwc2h1dHRlcnMlMjBibGluZHN8ZW58MHx8fHwxNzc3OTcyOTI5fDA&ixlib=rb-4.1.0&q=85",
    },
    {
      id: "sites",
      title: "Σίτες",
      description:
        "Λειτουργικές και διακριτικές σίτες για κάθε τύπο κουφώματος.",
      image:
        "https://images.unsplash.com/photo-1666679109000-58565a321da5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBsYXJnZSUyMGFsdW1pbml1bSUyMHdpbmRvdyUyMG5hdHVyZXxlbnwwfHx8fDE3Nzc5NzI5Mjl8MA&ixlib=rb-4.1.0&q=85",
    },
    {
      id: "pergoles",
      title: "Πέργκολες & Στέγαστρα",
      description:
        "Αναβαθμίστε τον εξωτερικό σας χώρο με ανθεκτικές κατασκευές αλουμινίου.",
      image:
        "https://images.unsplash.com/photo-1766087752966-b9a7b058b7da?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBvdXRkb29yJTIwcGVyZ29sYSUyMHBhdGlvfGVufDB8fHx8MTc3Nzk3MjkyNHww&ixlib=rb-4.1.0&q=85",
    },
    {
      id: "gyalina",
      title: "Γυάλινα Διαχωριστικά & Κάγκελα",
      description:
        "Minimal λύσεις για μπαλκόνια, σκάλες, επαγγελματικούς και εσωτερικούς χώρους.",
      image:
        "https://images.unsplash.com/photo-1760160134218-34eb3233a101?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBiYWxjb255JTIwZ2xhc3MlMjByYWlsaW5nfGVufDB8fHx8MTc3Nzk3MjkyOXww&ixlib=rb-4.1.0&q=85",
    },
  ],
};

export const why = {
  eyebrow: "Γιατί Alumak",
  title: "Ποιότητα που στέκει στον χρόνο",
  description:
    "Στη Alumak δεν προσφέρουμε απλά κουφώματα. Δημιουργούμε ολοκληρωμένες λύσεις που συνδυάζουν αντοχή, ασφάλεια, αισθητική και λειτουργικότητα.",
  items: [
    {
      icon: "Layers",
      title: "Ποιοτικά Υλικά",
      text: "Προφίλ αλουμινίου και εξαρτήματα από κορυφαίους ευρωπαϊκούς κατασκευαστές.",
    },
    {
      icon: "Wrench",
      title: "Άψογη Τοποθέτηση",
      text: "Έμπειρα συνεργεία με σεβασμό στη λεπτομέρεια και τον χώρο σας.",
    },
    {
      icon: "Leaf",
      title: "Ενεργειακή Απόδοση",
      text: "Υψηλές επιδόσεις θερμομόνωσης και ηχομόνωσης για άνετη διαβίωση.",
    },
    {
      icon: "Ruler",
      title: "Μοντέρνος Σχεδιασμός",
      text: "Minimal αισθητική με καθαρές γραμμές και διακριτικές λεπτομέρειες.",
    },
    {
      icon: "SlidersHorizontal",
      title: "Εξατομικευμένες Λύσεις",
      text: "Μελέτη και κατασκευή προσαρμοσμένη σε κάθε τύπο έργου και ανάγκη.",
    },
    {
      icon: "Headphones",
      title: "Υποστήριξη μετά την Παράδοση",
      text: "Συνεχής εξυπηρέτηση, συντήρηση και τεχνική υποστήριξη μετά την τοποθέτηση.",
    },
  ],
};

export const projects = {
  eyebrow: "Έργα",
  title: "Επιλεγμένες Κατασκευές",
  subtitle:
    "Ένα δείγμα των έργων μας σε κατοικίες, επαγγελματικούς χώρους και ξενοδοχειακές μονάδες.",
  filters: ["Όλα", "Κατοικίες", "Επαγγελματικοί Χώροι", "Ξενοδοχεία", "Εξωτερικοί Χώροι"],
  items: [
    {
      title: "Σύγχρονη Κατοικία με Minimal Κουφώματα",
      category: "Κατοικίες",
      description: "Συρόμενα θερμοδιακοπτόμενα συστήματα μεγάλων διαστάσεων.",
      image:
        "https://images.unsplash.com/photo-1766603636700-e9d80473f40f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBsdXh1cnklMjBob3VzZSUyMGV4dGVyaW9yJTIwbGFyZ2UlMjB3aW5kb3dzfGVufDB8fHx8MTc3Nzk3MjkyM3ww&ixlib=rb-4.1.0&q=85",
    },
    {
      title: "Βίλα με Πανοραμικές Υαλοστάσιες",
      category: "Κατοικίες",
      description: "Συστήματα minimal με κρυφό πλαίσιο και τριπλούς υαλοπίνακες.",
      image:
        "https://images.unsplash.com/photo-1766603636584-38baba9fcfd4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjB2aWxsYSUyMHNsaWRpbmclMjBnbGFzcyUyMGRvb3JzfGVufDB8fHx8MTc3Nzk3MjkyOXww&ixlib=rb-4.1.0&q=85",
    },
    {
      title: "Κτίριο Γραφείων με Γυάλινη Πρόσοψη",
      category: "Επαγγελματικοί Χώροι",
      description: "Ενεργειακά αποδοτικό curtain wall και στιβαρές εισόδους.",
      image:
        "https://images.unsplash.com/photo-1774099690798-c4fe300374b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBvZmZpY2UlMjBidWlsZGluZyUyMGdsYXNzJTIwZmFjYWRlfGVufDB8fHx8MTc3Nzk3MjkyM3ww&ixlib=rb-4.1.0&q=85",
    },
    {
      title: "Εμπορικό Κατάστημα — Είσοδος & Βιτρίνα",
      category: "Επαγγελματικοί Χώροι",
      description: "Σχεδιασμός για μέγιστη φυσική όραση και ασφάλεια.",
      image:
        "https://images.unsplash.com/photo-1776617130189-f56b5ac44534?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBvZmZpY2UlMjBidWlsZGluZyUyMGdsYXNzJTIwZmFjYWRlfGVufDB8fHx8MTc3Nzk3MjkyM3ww&ixlib=rb-4.1.0&q=85",
    },
    {
      title: "Boutique Ξενοδοχείο — Suites & Balconies",
      category: "Ξενοδοχεία",
      description: "Συρόμενα συστήματα, σίτες και σκίαση υψηλών προδιαγραφών.",
      image:
        "https://images.unsplash.com/photo-1777502036441-6f7f328924ca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjByZXNvcnQlMjBtb2Rlcm4lMjBleHRlcmlvcnxlbnwwfHx8fDE3Nzc5NzI5MjN8MA&ixlib=rb-4.1.0&q=85",
    },
    {
      title: "Resort με Ολική Ενεργειακή Αναβάθμιση",
      category: "Ξενοδοχεία",
      description: "Αντικατάσταση κουφωμάτων σε 64 δωμάτια χωρίς διακοπή λειτουργίας.",
      image:
        "https://images.unsplash.com/photo-1763914767111-b4451913ceba?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjByZXNvcnQlMjBtb2Rlcm4lMjBleHRlcmlvcnxlbnwwfHx8fDE3Nzc5NzI5MjN8MA&ixlib=rb-4.1.0&q=85",
    },
    {
      title: "Πέργκολα Βιοκλιματική σε Ιδιωτική Κατοικία",
      category: "Εξωτερικοί Χώροι",
      description: "Περιστρεφόμενες λάμες, LED φωτισμός, αυτοματισμοί.",
      image:
        "https://images.unsplash.com/photo-1766603636766-1f4662469448?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBvdXRkb29yJTIwcGVyZ29sYSUyMHBhdGlvfGVufDB8fHx8MTc3Nzk3MjkyNHww&ixlib=rb-4.1.0&q=85",
    },
    {
      title: "Αυλή με Γυάλινα Κάγκελα & Στέγαστρο",
      category: "Εξωτερικοί Χώροι",
      description: "Frameless glass και στέγαστρα αλουμινίου με φινίρισμα matt.",
      image:
        "https://images.unsplash.com/photo-1775733923991-e7223f9f44bc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBvdXRkb29yJTIwcGVyZ29sYSUyMHBhdGlvfGVufDB8fHx8MTc3Nzk3MjkyNHww&ixlib=rb-4.1.0&q=85",
    },
  ],
};

export const processData = {
  eyebrow: "Διαδικασία",
  title: "Πώς Συνεργαζόμαστε",
  subtitle:
    "Μια καθαρή, διαφανής διαδικασία τεσσάρων βημάτων — από την πρώτη επαφή έως την παράδοση.",
  steps: [
    {
      number: "01",
      title: "Επικοινωνία & Ανάλυση Αναγκών",
      text: "Συζητάμε το έργο σας, τις απαιτήσεις και τις προσδοκίες σας.",
    },
    {
      number: "02",
      title: "Μελέτη & Προσφορά",
      text: "Ετοιμάζουμε τεχνική μελέτη, επιλογές υλικών και αναλυτική προσφορά.",
    },
    {
      number: "03",
      title: "Κατασκευή & Προετοιμασία",
      text: "Προσεκτική κατασκευή στο εργαστήριο, με έλεγχο ποιότητας σε κάθε βήμα.",
    },
    {
      number: "04",
      title: "Τοποθέτηση & Παράδοση",
      text: "Έμπειρα συνεργεία αναλαμβάνουν την τοποθέτηση με σεβασμό στον χώρο σας.",
    },
  ],
};

export const showroom = {
  eyebrow: "Showroom",
  title: "Επισκεφθείτε το Showroom μας",
  text: "Δείτε από κοντά υλικά, χρώματα, μηχανισμούς και δείγματα κατασκευών. Η ομάδα μας θα σας βοηθήσει να επιλέξετε την κατάλληλη λύση για τον χώρο σας.",
  cta: "Κλείστε Ραντεβού",
  image:
    "https://images.unsplash.com/photo-1721739511094-f2288a8de83e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBibGFjayUyMGVudHJhbmNlJTIwZG9vciUyMGhvdXNlfGVufDB8fHx8MTc3Nzk3MjkyM3ww&ixlib=rb-4.1.0&q=85",
  bullets: [
    "Δείγματα κουφωμάτων σε φυσικές διαστάσεις",
    "Επιλογές χρωμάτων και φινιρισμάτων",
    "Τεχνικοί σύμβουλοι για εξατομικευμένη καθοδήγηση",
  ],
};

export const contact = {
  eyebrow: "Επικοινωνία",
  title: "Ζητήστε την Προσφορά σας",
  subtitle:
    "Συμπληρώστε τη φόρμα και θα επικοινωνήσουμε μαζί σας εντός 24 ωρών.",
  projectTypes: [
    "Κατοικία",
    "Επαγγελματικός Χώρος",
    "Ξενοδοχείο / Airbnb",
    "Ανακαίνιση",
    "Άλλο",
  ],
};
